import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/layout";

import Section from "../../components/organisms/section";
import Header from "../../components/organisms/header";
import Footer from "../../components/organisms/footer";
import FormApply from "../../components/organisms/form-apply";

import HeaderBrand from "../../components/molecules/header-brand";
import FooterBrand from "../../components/molecules/footer-brand";
import FooterNav from "../../components/molecules/footer-nav";
import FooterCopy from "../../components/molecules/footer-copy";
import NavBar from "../../components/molecules/navbar";
import HeaderTitle from "../../components/molecules/header-title";
import List from "../../components/molecules/list";
import ListItem from "../../components/molecules/list-item";
import ImageContainer from "../../components/molecules/image-container";
import HeaderSubfacet from "../../components/molecules/header-subfacet";
import ButtonApply from "../../components/molecules/button-apply";

import Seo from "../../components/atoms/seo";
import FormWrapper from "../../components/organisms/form-wrapper";
import Progress from "../../components/atoms/progress";
import Versus from "../../components/atoms/versus";

class RequirementsAndQaConsultant extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <Seo
          title="Nathalie  | Requirements &amp; QA Consultant | Silhouette"
          media="https://www.blastic.com/design/img/background/nathalie.jpg"
          description="Blastic is looking for a Requirements &amp; QA Consultant profile. The silhouette of one of our Requirements &amp; QA Consultants reveals what the job includes and what you can expect."
        />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <ButtonApply getTarget={() => document.getElementsByTagName("form")[0]}>
          Meet <br />
          <br />
          Nathalie
        </ButtonApply>
        <Section className="pt-5 py-sm-5">
          <HeaderTitle title="Nathalie | Requirements &amp; QA Consultant" />
          <div className="row">
            <div className="col-md-6 pb-6 order-2 order-md-1">
              <p>
                Communication is key in projects, and it all starts with a good
                definition. What will be built and what can our customers
                expect? These are our two first questions when we release a
                project or new functionalities.
              </p>
              <p>
                Before releasing new features, the developments by our technical
                team always receive an extra quality check, based on those
                expectations.
              </p>
              <p>
                That’s why I am involved in all phases of the project. I
                organize workshops with clients about their requirements and
                describe user stories in an understandable language for both our
                clients and our technical team. The most important part is the
                agreement on acceptance criteria that will be the baseline for
                the test cases and acceptance when we release a functionality.
                What is the definition of done?
              </p>
              <p>
                During the development sprints I participate in stand-up
                meetings to make sure everyone is on the same page. In parallel,
                I write test cases starting from the perspective of the end
                users as well as the administrator role or other roles that
                might be involved in the project. Also, front end test cases are
                described to check that the functionality is perfect whether it
                be mobile or desktop or every other possible device.
              </p>
              <p>
                During the test phase I perform tests to check the working
                functionalities. Every issue found is described in detail with
                clear steps to reproduce them. For regression testing I use
                automated testing tools to make my job easier. This helps me to
                test all functionalities when a release is done on production to
                check whether all features are working as they should be.
              </p>
              <p>
                That’s what my first question to you will be: which tools do you
                use to organize your user stories and to do testing?
              </p>
            </div>
            <div className="ml-auto col-md-5 order-1 order-md-2">
              <ImageContainer
                fluid={this.props.data.qaConsultant.childImageSharp.fluid}
                overlay="gradient"
                negateRight={true}
                negateBottom={true}
                aspectRatio="1x1-5"
              >
                <h3 className="h6">I'm looking for a colleague</h3>
                <HeaderSubfacet
                  title="Role"
                  value="Requirements & QA Consultant"
                />
                <HeaderSubfacet title="Experience" value="> 2 years" />
                <HeaderSubfacet
                  title="Location"
                  value="Client meetings, or our office in Edegem (Antwerp) or Ghent"
                />
                <HeaderSubfacet
                  title="Language"
                  value="NL / EN / Maybe some French"
                />
                <HeaderSubfacet
                  title="Pay"
                  value="2500 – 3500 euro + package (insurance, car & fuel card, …)"
                />
              </ImageContainer>
            </div>
          </div>
        </Section>
        <Section className="py-5 py-sm-7 section-shifted-left-blue">
          <div className="row">
            <div className="col-lg-11 ml-auto">
              <div className="row">
                <div className="col-sm-6">
                  <h2 className="h4 mb-2">What drives me in my job</h2>
                  <List>
                    <ListItem>
                      Analyze business problems and describing a functional
                      requirement
                    </ListItem>
                    <ListItem>
                      Clear requirements, everyone on the same page
                    </ListItem>
                    <ListItem>
                      Finding bugs in very specific yet realistic situations
                      from end-user perspective
                    </ListItem>
                    <ListItem>Automating my job for better ROI</ListItem>
                    <ListItem>
                      Challenging the team to increase the quality
                    </ListItem>
                  </List>
                </div>
                <div className="col-sm-6">
                  <h2 className="h4 mb-2 mt-sm-7">I'm turned off by</h2>
                  <List>
                    <ListItem>Obvious bugs</ListItem>
                    <ListItem>Bad user experience</ListItem>
                    <ListItem>Lack of ownership</ListItem>
                  </List>
                </div>
              </div>
            </div>
          </div>
        </Section>
        <Section className="py-5 py-sm-6 section-white">
          <div className="row">
            <div className="col-12 col-md-4 mr-auto negate-top pb-5 pb-md-0">
              <h2 className="h4">Personality</h2>
              <Versus
                value={80}
                scale={100}
                title="Introvert"
                titleOpponent="Extravert"
              />
              <Versus
                value={30}
                scale={100}
                title="Organized"
                titleOpponent="Chaotic"
              />
              <Versus value={50} scale={100} title="Think" titleOpponent="Do" />
              <Versus
                value={80}
                scale={100}
                title="Reserved"
                titleOpponent="Assertive"
              />
              <Versus
                value={30}
                scale={100}
                title="No-nonsense"
                titleOpponent="Diplomatic"
              />
              <Versus
                value={55}
                scale={100}
                title="Creative"
                titleOpponent="Analytical"
              />
            </div>
            <div className="col-6 col-md-4 col-lg-3 ml-auto">
              <h2 className="h4">Skills</h2>
              <Progress value={80} scale={100} title="Selenium " />
              <Progress value={95} scale={100} title="JIRA" />
              <Progress value={75} scale={100} title="Azure DevOps" />
              <Progress value={60} scale={100} title="Snaptest" />
              <Progress value={70} scale={100} title="Wireframing tools" />
            </div>
            <div className="col-6 col-md-4 col-lg-3 mx-auto">
              <h2 className="h4">Motivators</h2>
              <Progress value={100} scale={100} title="Team spirit" />
            </div>
          </div>
        </Section>
        <FormWrapper path="QA-consultant">
          <FormApply className="section-grey">
            <h2 className="form-title mb-4">Meet Nathalie</h2>
            <div className="row">
              <div className="col-md-6 mb-4 mr-auto">
                <p>
                  Does the above sound interesting to you? Perfect! We’d love to
                  hear from you. You’ll meet Nathalie first to discuss your own
                  Requirements &amp; QA Consultant position. Fill out the form
                  below and we’ll get back to you soon.
                </p>
              </div>
            </div>
          </FormApply>
        </FormWrapper>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    qaConsultant: file(relativePath: { eq: "background/nathalie.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 600) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default RequirementsAndQaConsultant;
